import React, { FC } from 'react';
import { Typography } from '@mui/material';
import theme from 'theme';
import { TextAnswersProps } from './types';

const TextAnswers: FC<TextAnswersProps> = props => {
  const { answers } = props;

  return (
    <>
      {answers?.map(answer => (
        <React.Fragment key={answer.id}>
          <Typography
            style={{
              fontWeight: 400,
              color: theme.palette.black,
              fontSize: '1rem',
              display: 'inline',
              wordBreak: 'break-word',
            }}>
            {answer.text_answer}
          </Typography>
        </React.Fragment>
      ))}
    </>
  );
};

export default TextAnswers;
